export const EMAIL_PROVIDER = [
  "aim",
  "alice",
  "aliceadsl",
  "aol",
  "arcor",
  "att",
  "bellsouth",
  "bigpond",
  "bluewin",
  "blueyonder",
  "bol",
  "centurytel",
  "charter",
  "chello",
  "club-internet",
  "comcast",
  "earthlink",
  "facebook",
  "free",
  "freenet",
  "frontiernet",
  "gmail",
  "gmx",
  "googlemail",
  "hetnet",
  "home",
  "hotmail",
  "ig",
  "juno",
  "laposte",
  "libero",
  "live",
  "mac",
  "mail",
  "me",
  "msn",
  "neuf",
  "ntlworld",
  "optonline",
  "optusnet",
  "orange",
  "outlook",
  "planet",
  "qq",
  "rambler",
  "rediffmail",
  "rocketmail",
  "sbcglobal",
  "sfr",
  "shaw",
  "sky",
  "skynet",
  "sympatico",
  "t-online",
  "telenet",
  "terra",
  "tin",
  "tiscali",
  "unaref",
  "uol",
  "verizon",
  "virgilio",
  "voila",
  "wanadoo",
  "web",
  "windstream",
  "yahoo",
  "yandex",
  "zonnet",
];
